import { createApp } from 'vue'
import libphonenumber from 'google-libphonenumber'
import Datepicker from '@vuepic/vue-datepicker'
import utilMixin from '../util_mixin.js';

function scrollToFirstError() {
  const el = document.querySelector('.error')
  if (el) {
    el.scrollIntoView()
  }
}

export default (data) => {

  const vm = createApp({
    mixins: [utilMixin],
    components: {
        'datepicker': Datepicker,
    },
    data: () => (data/* form,error,validations,dictionary,holidays,form_control */),
    methods: {
      setAddressByZip: function (zipVarStr, prefVarStr, addr1VarStr, event) {

        let _this = this;
        let zip   = this.convertHankakuZip(this.form[zipVarStr]);
        this.form[zipVarStr] = zip;

        if (8 != zip.length) {
          return;
        }

        new window.YubinBango.Core(zip, function(addr) {
            _this.form[prefVarStr]    = addr.region_id // 都道府県ID
            _this.form[addr1VarStr]   = addr.locality +  addr.street // 市区町村
        })
      },
      katakanaToHiragana: function (datakey) {
          this.form[datakey] = this.form[datakey].replace(/[ァ-ン]/g, function(s) {
              return String.fromCharCode(s.charCodeAt(0) - 0x60);
          });
      },
      toZenkakuKatakana: function (datakey) {
          this.form[datakey] = this.convertZenkakuKatakana(this.form[datakey]);
      },
      zenToHan: function (datakey) {
          this.form[datakey] = this.convertHankaku(this.form[datakey]);
      },
      deleteZenkaku: function (event) {
          return event.target.value = this.delZen(event.target.value);
      },
      uploadFileSet: function (specify_key, event, maxsize_kb, mimes) {
        let file = event.target.files[0];
        if( !this.checkUploadFile(file, maxsize_kb, mimes) ) {
          event.target.value                 = '';
          this.form[specify_key+'_filename'] = '';
          this.form[specify_key+'_upload'] = '';
          return false;
        }
        this.form[specify_key+'_filename'] = file.name;
        this.errors[specify_key] = null;
        this.errors[specify_key+'_filename'] = null;
        this.errors[specify_key+'_upload'] = null;
        return true;
      },
      checkUploadFile: function (file, maxsize_kb, mimes) {
        if (!file) {
          return false;
        }
        if (file.size > (1024 * maxsize_kb)) {
          let alert_size = maxsize_kb+'KB';
          if(maxsize_kb > 999) {
            alert_size = Math.ceil(maxsize_kb/1024)+'MB';
          }
          alert('ファイルが'+alert_size+'を超えています。\n'+alert_size+'以下のファイルをアップロードしてください。');
          return false;
        }

        if (mimes.length > 0 && !mimes.includes(file.type) ) {
          alert('対応していない拡張子です');
          return false;
        }
        return true;
      },
      selectInit: function (initselect, datakey) {
        if((typeof this['selectInitCtrl'+datakey]) === 'undefined'
        && !this.form[datakey] ){
          this.form[datakey] = initselect;
          
        }
        this['selectInitCtrl'+datakey] = true;
      },
      telTreat: function (datakey) {
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        if( !this.form[datakey] ) {
          return;
        }
        try {
          const parsedPhoneNumber = phoneUtil.parse(this.form[datakey], 'JP');
          const isValid = phoneUtil.isValidNumber(parsedPhoneNumber);
  
          if (isValid) {
            this.form[datakey] = phoneUtil.format(parsedPhoneNumber, libphonenumber.PhoneNumberFormat.NATIONAL);
          } else {
            console.log('Invalid phone number');
          }
        } catch (error) {
          console.log('Error parsing phone number:', error);
        }
      },
      isEnableDay: function( this_option_val, daycolumnName, yearColumnName, monthColumnName ) {
        var year_val  = this.form[yearColumnName];
        var month_val = this.form[monthColumnName];
        if( !this_option_val || !year_val || ((month_val !== 0) && !month_val)) {
          return true;
        }

        const year_matches = year_val.match(/(\d{4})年/);
        if (year_matches) {
          year_val = parseInt(year_matches[1], 10);
        } else {
          console.error('dayCheck year logic error');
          return true;
        }

        const month_matches = month_val.match(/\d+/);
        if (month_matches) {
          month_val = parseInt(month_matches[0], 10);
        } else {
          console.error('dayCheck month logic error');
        }

        const lastDate = new Date(year_val, month_val, 0);
        const lattDayNum = lastDate.getDate();
        if(lattDayNum >= parseInt(this_option_val)) {
          // その月の最終日以内であれば
          return true;
        }
        // 非活性にする際、その値が設定値であるならば
        if(this.form[daycolumnName] === this_option_val) {
          this.form[daycolumnName] = "";
        }
        return false;
      },
      strSizeDisp: function (datakey) {
        if(!this.form[datakey]){
          return 0;
        }
        return this.form[datakey].length.toLocaleString();
      },
      compareColumn: function (confirm_datakey, src_datakey) {
        let on_error = false;
        if( !!this.form[confirm_datakey] 
            && this.form[confirm_datakey] !== this.form[src_datakey] ) {
          this.errors[confirm_datakey] = this.dictionary[src_datakey]+'は確認用項目と一致してません。';
          on_error = true;
        }
        return on_error;
      },
      clearRequiredError: function(columnName) {
        if( !this.form_control[columnName]['required'] ) {
          // 必須エラーがある場合...判定
          if(this.errors[columnName] && this.errors[columnName].includes('が入力されていません。')) {
            this.errors[columnName] = null;
          }
        }
      },
      clearEmptyError: function(columnName, oldVal, newVal) {
        if(  this.validations[columnName].indexOf('required') >= 0 ){
          if( ( !oldVal || (Array.isArray(oldVal) && oldVal.length <= 0 ) /* 古い値は必須エラー */ 
            && !(!newVal || (Array.isArray(newVal) && newVal.length <= 0) ))) /* 新しい値は必須エラーではない */ {
              this.errors[columnName] = null;
          }
        }

      },
      convertColumnData:  function(columnName) {
        if(this.validations[columnName].indexOf('zip') >= 0) {
          let zip   = this.convertHankakuZip(this.form[columnName]);
          this.form[columnName] = zip;
        }
      },
      validateColumn: function (columnName, val) {
        let on_error = false;
        this.errors[columnName] = null;

        if( !this.form_control[columnName]['disp'] ) {
          return on_error;
        }

        if( this.form_control[columnName]['required'] && !this.form_control[columnName]['file'] 
            && (!val || (Array.isArray(val) && val.length <= 0 ) ) ) {
          // 必須判定
          this.errors[columnName] = this.dictionary[columnName]+"が入力されていません。";
          on_error = true;
        } else if( this.form_control[columnName]['required'] && this.form_control[columnName]['file'] 
            && !(!!this.form[columnName+'_upload'] || !!this.form[columnName+'_filename']) ) {
          // 必須判定(ファイル)
          this.errors[columnName] = this.dictionary[columnName]+"が入力されていません。";
          on_error = true;
        } else if( !!val ) {
          // 値が入力されている場合
          if (this.validations[columnName].indexOf('katakana') >= 0 && !this.isKatakanaOrSpace(val))
          {
            this.errors[columnName] = "カタカナで正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('hankaku') >= 0 && !this.isAlphanumeric(val)) {
            this.errors[columnName] = "半角英数字で正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('hankaku_num') >= 0 && !this.isHalfWidthDigits(val))
          {
            this.errors[columnName] = "半角数字で正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('tel') >= 0 && !this.isHalfWidthDigitsAndHyphen(val))
          {
            this.errors[columnName] = this.dictionary[columnName]+"を正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('zip') >= 0 && !this.isZip(val))
          {
            this.errors[columnName] = this.dictionary[columnName]+"を正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('emails') >= 0 && !this.isEmail(val))
          {
            this.errors[columnName] = "メールアドレスを正しく入力してください。";
            on_error = true;
          }
          else if (this.validations[columnName].indexOf('url') >= 0 && !this.isUrl(val))
          {
            this.errors[columnName] = "URLを正しく入力してください。";
            on_error = true;
          }
          else if ( this.getKeyByStartStr(this.validations[columnName], 'same:') ) {
            const keyinfo = this.getKeyByStartStr(this.validations[columnName], 'same:');
            const compareColumnName = keyinfo.split(':')[1];
            if( val !== this.form[compareColumnName] ) {
              this.errors[columnName] = this.dictionary[compareColumnName]+'は確認用項目と一致してません。';
              on_error = true;
            }
          }
          else if ( this.getKeyByStartStr(this.validations[columnName], 'reject_mail_domain:') ) {
            const keyinfo = this.getKeyByStartStr(this.validations[columnName], 'reject_mail_domain:');
            const rejectDomains = keyinfo.split(':')[1];
            rejectDomains.split(',').forEach( (rejectDomain) => {
              if( this.isEmail(val) && val.endsWith('@'+rejectDomain) ) {
                this.errors[columnName] = 'ご入力のメールアドレスは利用できません。';
                on_error = true;
                return false;
              }
            });
          }
        }
        return on_error;
      },
      kickRequireDispControl: function(columnName, val) {
        let setting = this.form_control[columnName];
        
        if( Array.isArray(setting['control_disp']) ) {
            setting['control_disp'].forEach( (oneset) => {
              this.judgeDispControl(oneset['name']);
            });
        }
        if( Array.isArray(setting['control_required']) ) {
          setting['control_required'].forEach( (oneset) => {
            this.judgeRequiredControl(oneset['name']);
            this.clearRequiredError(oneset['name'], this.form[oneset['name']]);
          });
        }
      },
      judgeDispControl: function(columnName) {
        if( !Array.isArray(this.form_control[columnName]['disp_if']) ) {
          return;
        }
        this.form_control[columnName]['disp'] = false;
        this.form_control[columnName]['disp_if'].forEach( (oneset) => {
          if( !Array.isArray(this.form[ oneset['name']]) ) {
            if( this.form[ oneset['name'] ] === oneset['value'] ) {
              this.form_control[columnName]['disp'] = true;
              return false;
            }  
          } else {
            if( this.form[ oneset['name'] ].includes(oneset['value']) ) {
              this.form_control[columnName]['disp'] = true;
              return false;
            }
          } 
        })
      },
      judgeRequiredControl: function(columnName) {
        const _this = this;
        if( !Array.isArray(this.form_control[columnName]['required_if']) ) {
          return;
        }
        
        // 条件が満たされたかのフラグ
        let hasRequiredTrue = false;   // required_off=falseの条件が満たされた
        let hasRequiredFalse = false;  // required_off=trueの条件が満たされた
        
        // 条件タイプの存在確認
        let hasRequiredOffTrue = false;  // required_off=trueの設定が存在する
        let hasRequiredOffFalse = false; // required_off=falseの設定が存在する
        
        // 設定タイプの確認
        this.form_control[columnName]['required_if'].forEach(oneset => {
          if(oneset['required_off']) {
            hasRequiredOffTrue = true;
          } else {
            hasRequiredOffFalse = true;
          }
        });
        
        this.form_control[columnName]['required_if'].forEach( (oneset) => {
          let conditionMet = false;
          
          if( !Array.isArray(this.form[ oneset['name']]) ) {
            // 単一値の場合
            conditionMet = (this.form[ oneset['name'] ] === oneset['value']);
          } else {
            // 配列値の場合
            conditionMet = this.form[ oneset['name'] ].includes(oneset['value']);
          }
          
          if(conditionMet) {
            if( oneset['required_off'] ) {
              hasRequiredFalse = true;
            } else {
              hasRequiredTrue = true;
            }
          }
        });
        
        // 優先順位: required_off=trueが優先
        if(hasRequiredFalse) {
          this.form_control[columnName]['required'] = false;
        } else if(hasRequiredTrue) {
          this.form_control[columnName]['required'] = true;
        } else {
          // デフォルト値の決定
          if(hasRequiredOffTrue && !hasRequiredOffFalse) {
            // ①required_offの設定のみの場合、デフォルトはtrue
            this.form_control[columnName]['required'] = true;
          } else if(!hasRequiredOffTrue && hasRequiredOffFalse) {
            // ②required_offではない設定のみの場合、デフォルトはfalse
            this.form_control[columnName]['required'] = false;
          } else {
            // ③required_offの設定と含まれない設定が混在する場合、デフォルトはfalse
            this.form_control[columnName]['required'] = false;
          }
        }
      },
      kickDisabledControl: function(columnName, val) {
        this.judgeDisabledControl(columnName, val);
      },
      judgeDisabledControl: function(columnName, val) {
        if( !Array.isArray(this.form_control[columnName]['disabled_if'])
            && !Array.isArray(this.form_control[columnName]['active_if']) ) {
          return;
        }
        
        if( Array.isArray(val) ) {
          // 複数選択
          if( Array.isArray(this.form_control[columnName]['disabled_if']) ) {
            console.log('multipleanswser not supported disabled_if');
          }

          if( Array.isArray(this.form_control[columnName]['active_if']) ) {
            this.form_control[columnName]['active_if'].forEach((oneset) => {
              if (Array.isArray(val) && Array.isArray(oneset.value) && oneset.value.some(v => val.includes(v))) {
                this.form_control[oneset.name]['disabled'] = false;
              } else {
                this.form_control[oneset.name]['disabled'] = true;
              }
            });
          }
        } else {
          // 単数選択
          if( Array.isArray(this.form_control[columnName]['disabled_if']) ) {
            this.form_control[columnName]['disabled_if'].forEach( (oneset) => {
              if( !Array.isArray( oneset.value ) ) {
                if( val === oneset.value ) {
                  this.form_control[oneset.name]['disabled'] = true;
                } else {
                  this.form_control[oneset.name]['disabled'] = false;
                }
              } else {
                if( oneset.value.includes(val) ) {
                  this.form_control[oneset.name]['disabled'] = true;
                } else {
                  this.form_control[oneset.name]['disabled'] = false;
                }
              }
              return false;
            });
          }

          if( Array.isArray(this.form_control[columnName]['active_if']) ) {
            this.form_control[columnName]['active_if'].forEach( (oneset) => {
              if( val === oneset.value ) {
                this.form_control[oneset.name]['disabled'] = false;
              } else {
                this.form_control[oneset.name]['disabled'] = true;
              }
            });
          }
        }
      },
      kickOptionControl: function(columnName, val) {
        let _this = this;
        let control_names = this.judgeOptionControl(columnName, val);

        control_names.forEach( (control_name) => {
          // 変更したものに関して選択肢がなくなったら空に戻す
          const option = this.options[control_name];
          const validValues = option.map(opt => opt.key);
          if( Array.isArray(this.form[control_name]) ) {
            this.form[control_name] = this.form[control_name].filter(val => validValues.includes(val));
          } else {
            if (!validValues.includes(this.form[control_name])) {
              this.form[control_name] = '';
            }
          }
        })
      },
      judgeOptionControl: function(columnName, val) {
        if( !Array.isArray(this.form_control[columnName]['control_option']) ) {
          return [];
        }
        
        let control_names = [];
        this.form_control[columnName]['control_option'].forEach( (oneset) => {

          control_names.push(oneset.name);

          if( oneset.value === val ) {
            Object.entries(oneset.add_option).forEach(([key, value]) => {
              let existingOption = this.options[oneset.name].find(option => option.key === key);
              if (existingOption) {
                existingOption.cnt = (existingOption.cnt || 1) + 1;
              } else {
                this.options[oneset.name].push({ 'key': key, 'value': value, 'cnt': 1 });
              }
            });
          } else {
            // 一致しない値のcntを減らし、0になったら削除
            this.options[oneset.name] = this.options[oneset.name].filter(option => {
              if (Object.keys(oneset.add_option).includes(option.key)) {
                option.cnt = (option.cnt || 1) - 1;
                return option.cnt > 0;
              }
              return true;
            });
          }
        });
        return control_names;;
      },
      checkBlurVal: function(columnName) {
        this.validateColumn(columnName, this.form[columnName]);
      },
      checkRowDisp: function(columns) {
        let ret = false;
        columns.forEach((columnName) => {
          if(this.form_control[columnName]['disp']) {
            ret = true;
          }
        });
        return ret;
      },
      checkRowRequired: function(columns) {
        let ret = false;
        columns.forEach((columnName) => {
          if(this.form_control[columnName]['required']) {
            ret = true;
          }
        });
        return ret;
      },
      checkDisabled: function(columnName) {
        let ret = this.form_control[columnName]['disabled'] && this.form_control[columnName]['disabled'] === true ? true : false;
        return ret;
      },
      startValWatching: function(columnName) {
        this.$watch(
          `form.${columnName}`,
          (newVal, oldVal) => {
            this.clearEmptyError(columnName,oldVal,newVal);
            this.kickRequireDispControl(columnName, newVal);
            this.kickOptionControl(columnName, newVal);
            this.kickDisabledControl(columnName, newVal);
          }
        );
      },
      startFormWatching: function() {
        Object.keys(this.form).forEach(columnName => {
          this.startValWatching(columnName);
        });
      },
      initFormDisp: function() {
        Object.keys(this.form).forEach(columnName => {
          this.judgeOptionControl(columnName, this.form[columnName]);
          this.judgeDispControl(columnName);
          this.judgeRequiredControl(columnName);
          this.judgeDisabledControl(columnName, this.form[columnName]);
        });
      },
      handlePreSubmit: function(event) {
        let err = false; 
        Object.keys(this.form).forEach(columnName => {
          this.convertColumnData(columnName);
          let tmp = this.validateColumn(columnName, this.form[columnName]);
          if(tmp) {
            err = true;
          }
        });
        
        if(err) {
          // エラー有り
          event.preventDefault();
          setTimeout(() => {
            // Vueの描画との時差を考慮したタイムアウト
            scrollToFirstError();
          }, 100);
        }
      },
    },
    watch: {
    },
    computed: {
    },
    mounted: function() {
      this.startFormWatching();
      this.initFormDisp();
      scrollToFirstError()
    }
  }).mount('#form_container')
}
